import { Injectable } from "@angular/core";
import {
  ChassiClient,
  ChassiViewModel,
  SearchVehicleRequestModel,
} from "src/domain/client";

@Injectable({
  providedIn: "root",
})
export class ChassiService {
  constructor() {}

  getChassiByRegNr(regNr: string): Promise<ChassiViewModel> {
    const requestModel = new SearchVehicleRequestModel({
      regNr,
    });

    return new ChassiClient().chassi(requestModel);
  }
}
